import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import type { ElasticVehicle } from '../../@types/ElasticVehicle';
import { getQueryFilter } from '../../utils/reselectors';
import SearchSubscription from '../subscriptions/search-subscription';
import ResultSetContainer from './result-set-container';

interface ResultSetProps {
  data: ElasticVehicle[];
  title?: string;
  disableScrollTopButton?: boolean;
  shouldHideAds?: boolean;
}

const ResultSet = ({ data, title, disableScrollTopButton, shouldHideAds }: ResultSetProps) => {
  const queryFilter = useSelector(getQueryFilter);

  const [subscribe, setSubscribe] = useState(false);
  const [visibleFilterScroll, setVisibleFilterScroll] = useState(false);

  const onScroll = () => {
    let offset = 0;
    if (document.documentElement) {
      offset = document.documentElement.scrollTop;
    }

    if (offset < 0) {
      offset = 0;
    }

    if (offset > 150 && !visibleFilterScroll) {
      setVisibleFilterScroll(true);
    } else if (offset <= 150 && visibleFilterScroll) {
      setVisibleFilterScroll(false);
    }
  };

  useEffect(() => {
    if (!disableScrollTopButton) {
      document.addEventListener('scroll', onScroll);
    }
    return () => {
      document.removeEventListener('scroll', onScroll);
    };
  }, [visibleFilterScroll]);

  if (!data) {
    return null;
  }

  return (
    <>
      {subscribe && (
        <SearchSubscription onClose={() => setSubscribe(false)} query={queryFilter.toString()} />
      )}
      <ResultSetContainer data={data} title={title} shouldHideAds={shouldHideAds} />
    </>
  );
};

export default ResultSet;
